import { getSrcs } from '@helpers/image';
import * as React from 'react';
import S from './HeroBanner.styles';
const HeroBanner = (props) => {
    if (!props.item) {
        return null;
    }
    return (React.createElement(S.Container, { flush: "both", variant: props.variant ?? 'black', style: { '--tint': props.gradient ?? 0.5 } },
        React.createElement(S.List, null, props.item && renderItem(props.item))));
    function renderItem(item) {
        const srcs = getSrcs(item.image, 2568, 375, 10, 0.5625);
        const mobileSrcs = getSrcs(item.mobileImage ?? item.image, 1400, 375, 5);
        return (React.createElement(S.Item, { key: item.id },
            React.createElement(S.ImageWrapper, null,
                React.createElement(S.DesktopMedia, null,
                    React.createElement(S.Image, { alt: item.image?.altText ?? '', loading: "eager", role: item.image?.altText ? undefined : 'presentation', src: srcs[0], srcSet: srcs.join(',') })),
                React.createElement(S.MobileMedia, null,
                    React.createElement(S.Image, { alt: item.mobileImage?.altText ?? '', loading: "eager", role: item.mobileImage?.altText ? undefined : 'presentation', src: mobileSrcs[0], srcSet: mobileSrcs.join(',') })),
                React.createElement(S.Overlay, null),
                React.createElement(S.MobileTitle, null, item.title)),
            React.createElement(S.Inner, null,
                React.createElement(S.TitleArea, null,
                    React.createElement(S.Title, null, item.title),
                    props.item.content && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.item.content } })))),
            props.item.content && (React.createElement(S.ContentAreaMobile, null,
                React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.item.content } })))));
    }
};
export default HeroBanner;
